import React from 'react'

import { Grid } from '@mui/material'
import debounce from 'lodash/debounce'

import { FormTextField } from 'components/input'
import { withForm } from 'decorators/withForm'

const NameToDomainFilters = () => (
  <Grid container spacing={2} style={{ width: 400 }} sx={{ justifyContent: 'flex-end' }}>
    <Grid
      size={{
        sm: 6,
      }}>
      <FormTextField label="Search alias..." name="query" />
    </Grid>
  </Grid>
)

export default withForm({
  form: 'nameToDomainFilters',
  onChange: debounce((values: any, _dispatch: any, props: any) => props.onSearch(values.query), 500),
})(NameToDomainFilters)
